import { InputFieldTypeEnum } from "../../../entityTemplates/inputFields/InputFields.types";
import { FilterOptionType } from "./FilterPopover.types.ts";

export function mapInputFieldTypeToFilterOptionType(inputFieldType: InputFieldTypeEnum): FilterOptionType {
    switch (inputFieldType) {
        case InputFieldTypeEnum.TextField:
        case InputFieldTypeEnum.RichTextField:
            return FilterOptionType.TextField;

        case InputFieldTypeEnum.SingleDropDown:
        case InputFieldTypeEnum.MultiDropDown:
        case InputFieldTypeEnum.LegalEntityField:
        case InputFieldTypeEnum.UserField:
        case InputFieldTypeEnum.CountryField:
            return FilterOptionType.SelectField;

        case InputFieldTypeEnum.DateField:
            return FilterOptionType.DateField;

        case InputFieldTypeEnum.NumberField:
        case InputFieldTypeEnum.DatePeriodField:
            return FilterOptionType.Number;

        case InputFieldTypeEnum.AmountField:
        case InputFieldTypeEnum.CalculatedField:
            return FilterOptionType.Amount;

        case InputFieldTypeEnum.CheckboxField:
            return FilterOptionType.Boolean;

        default:
            return FilterOptionType.TextField;
    }
}
